import { homeDeliverySlugsB2C, overviewTypes } from '@boss/constants/b2b-b2c';
import type { Theme } from '@boss/types/b2b-b2c';

import { mergeOptions } from '../default';

const bgDefinition = 'bg-gray before:bg-gray after:bg-gray';

const sectionBgColorMap = {
  'Colora: pink': 'bg-pink-light before:bg-pink-light after:bg-pink-light',
  'Colora: green': 'bg-green-soft before:bg-green-soft after:bg-green-soft',
  'Colora: blue': 'bg-blue-soft before:bg-blue-soft after:bg-blue-soft',
  'Colora: grey': 'bg-grey-light before:bg-grey-light after:bg-grey-light',
  'Colora: beige': 'bg-beige-light before:bg-beige-light after:bg-beige-light',
  'B2B: Dark green': bgDefinition,
  'B2B: Muted red': bgDefinition,
  'B2B: Muted blue': bgDefinition,
  'B2B: Forest green': bgDefinition,
};

const options = mergeOptions({
  youtubeLink: {
    nl: 'https://youtube.com/playlist?list=PLOYDlCDoO5uC4ASGTakQqgvDIM-xTebD_&si=p0PL_kHZtV9Kxk93',
    'nl-NL': 'https://youtube.com/playlist?list=PLOYDlCDoO5uC4ASGTakQqgvDIM-xTebD_&si=p0PL_kHZtV9Kxk93',
    fr: 'https://youtube.com/playlist?list=PLOYDlCDoO5uAaCtSEQberEfz807b2cj46&si=HFYEF3zS--ogYaZQ',
  },
  getSectionBgColor: (theme: Theme) => (theme ? sectionBgColorMap[theme] : null),
  sectionQuoteProps: { focus: 'quote', className: 'gap-10 items-center md:min-h-50', variant: 'primary' },
  sectionQuoteQuoteProps: { className: 'my-auto' },
  sectionQuoteImageProps: { round: 'all', square: 'bl', className: 'md:absolute object-contain' },
  productCardVariant: 'primary',
  storeFinderVariant: 'primary',
  storeCardVariant: 'primary',
  storeCardCtaVariant: 'link',
  storeCardCtaButtonType: 'secondary',
  orderCardVariant: 'primary',
  storeDetailTheme: 'Colora: pink',
  priceConfig: {
    visible: true,
  },
  accountPages: ['DASHBOARD', 'INFO', 'QUOTATION', 'ORDERS', 'ADVICE', 'PROJECTS', 'PAINTGUIDES', 'CONTACT'],
  accountNavigation: {
    navigationType: 'primary',
    mainNav: ['DASHBOARD', 'INFO', 'QUOTATION', 'ORDERS', 'ADVICE'],
    atelierNav: ['PROJECTS', 'PAINTGUIDES'],
    personalNav: ['CONTACT', 'LOGOUT'],
  },
  accountPageConfig: {
    showBreadcrumb: false,
    customHeader: true,
    variant: 'primary',
    listPageTypeToShow: 'PROJECTS',
    contactPageTypeToShow: 'CONTACT',
    wishlistType: 'product',
  },
  currentMarket: process.env.NEXT_PUBLIC_HOST_COLORA_NL ? 'NL' : 'BE',
  accountDashboardVariant: 'primary',
  productLabelVisibilityConfig: {
    'bossflash-action': 'hide',
    personal: 'hide',
    pallet: 'hide',
    campaign: 'show',
  },
  isB2b: false,
  pageOptions: {
    mainCategoryOverview: {
      breadcrumbVisibility: false,
    },
  },
  categoryPageConfig: {
    showPaintGuideLink: true,
  },
  homeDeliverySlugs: homeDeliverySlugsB2C,
  accountContactInformationType: 'B2C contact information',
  seoConfig: { titleSuffixContent: 'colora.be', titleSuffixContentNl: 'colora.nl' },
  storeConfig: {
    sortPriorityStoreType: 'Colora',
    excludeNamePrefix: 'BOSS paints',
    lowerCasePrefix: 'colora',
    shopsOnly: true,
  },
  surfaceCalculationConfig: {
    showTechnique: false,
  },
  overviewPageTypes: [overviewTypes.PAINTING_TIPS, overviewTypes.COLOR_TIPS, overviewTypes.INSIDE_VIEWER],
  eventType: 'WORKSHOP',
});

export default options;
